import {
    initialOpenSubmissionsStreamState,
    OpenSubmissionsDataState,
} from './stream/OpenSubmissionsStreamDataState';
import {
    OpenSubmissionsConfiguration,
    initialOpenSubmissionsConfiguration,
} from './configuration/OpenSubmissionsConfiguration';

import { StreamingWidgetState } from 'widgets/store/stream/WidgetStreamState';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';

export type OpenSubmissionsWidgetState =
    StreamingWidgetState<OpenSubmissionsDataState> &
        WidgetWithConfigState<OpenSubmissionsConfiguration>;

export interface OpenSubmissionsWidgetsState {
    [widgetId: string]: OpenSubmissionsWidgetState;
}

export const initialOpenSubmissionsWidgetState: OpenSubmissionsWidgetState = {
    config: initialOpenSubmissionsConfiguration,
    stream: initialOpenSubmissionsStreamState,
};

export const initialOpenSubmissionsWidgetsState: OpenSubmissionsWidgetsState =
    {};
